import { createContext } from "react";


export const initialState = {
  selectedProducts: [],
};

const ConfigContext = createContext(initialState);

export const { Provider } = ConfigContext;

export default ConfigContext;
